import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "areaSources",
    defaultRoutePath: "/commercials/areaSource",
    menuItemScope: "operations",
    menuItemName: "areaSource",

    routes: [
        {
            path: "/commercials/areaSource",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component:Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        
        {
            path: "create",
            Component: Views.Create,
        },
        
        {
            path: "manage",
            Component: Wizards.Manage,
        },
    ],

}

export default Module;
